<template>
  <div class="bcb-partner-edit container-fluid">
    <div class="d-flex align-items-center my-6">
      <button class="btn btn-icon btn-light mr-3" @click="$router.push({ name: 'bcb-partner' })">
        <i class="fas fa-arrow-left"></i>
      </button>
      <div>
        <h4 class="text-dark fw-bold mb-1">{{ isEdit ? 'Chỉnh sửa đối tác' : 'Thêm đối tác mới' }}</h4>
        <p class="text-muted m-0">BCB Bundle — Đối tác</p>
      </div>
    </div>

    <b-overlay :show="loading">
      <div class="bg-white rounded border p-6">
        <div class="row">
          <div class="col-md-6">
            <basic-input
              label="Tên đối tác (*)"
              placeholder="Nhập tên đối tác"
              name="name"
              :value.sync="form.name"
              :state="validated && !form.name ? false : null"
              invalid-feedback="Tên đối tác không được để trống."
              required
            />
          </div>
          <div class="col-md-6">
            <basic-input
              label="Số điện thoại"
              placeholder="Nhập số điện thoại"
              name="phone"
              :value.sync="form.phone"
              :state="validated && !form.phone ? false : null"
              invalid-feedback="Số điện thoại không được để trống."
              required
              :input-number="true"
              maxlength="11"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <basic-input
              label="Email"
              placeholder="Nhập email"
              name="email"
              type="email"
              :value.sync="form.email"
            />
          </div>
          <div class="col-md-6">
            <basic-select
              label="Trạng thái"
              placeholder="Chọn trạng thái"
              name="isActive"
              :options="activeOptions"
              required
              track-by="value"
              value-label="text"
              :value.sync="activeValue"
              @input="form.isActive = $event != null ? $event : true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <basic-text-area
              label="Địa chỉ"
              placeholder="Nhập địa chỉ đối tác"
              name="address"
              :value.sync="form.address"
              :rows="3"
            />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-light mr-3" @click="$router.push({ name: 'bcb-partner' })">Huỷ</button>
          <LoadingButton v-if="isEdit ? isUpdatePermission : isInsertPermission" class="btn btn-success" :handler="save">
            {{ isEdit ? 'Lưu thay đổi' : 'Thêm đối tác' }}
          </LoadingButton>
        </div>
      </div>

      <div v-if="isEdit" class="bg-white rounded border p-6 mt-6">
        <bcb-schedule-day-management :partner-id="partnerId" />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import BcbScheduleDayManagement from './BcbScheduleDayManagement.vue';

export default {
  name: 'BcbPartnerEdit',
  components: { BcbScheduleDayManagement },
  props: {
    id: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,
      validated: false,
      form: {
        name: '',
        phone: '',
        email: '',
        address: '',
        isActive: true,
      },
      activeOptions: [
        { value: true, text: 'Hoạt động' },
        { value: false, text: 'Không hoạt động' },
      ],
    };
  },
  computed: {
    isEdit() {
      return !!(this.id || this.$route.params.id);
    },
    partnerId() {
      return this.id || this.$route.params.id || null;
    },
    activeValue: {
      get() {
        return this.activeOptions.find((o) => o.value === this.form.isActive) || null;
      },
      set(obj) {
        this.form.isActive = obj?.value ?? true;
      },
    },
  },
  watch: {
    '$route.params.id'() {
      if (this.isEdit) this.loadData();
    },
  },
  created() {
    if (this.isEdit) this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const res = await this.$api.get(`BcbPartner/${this.partnerId}`);
        const data = res?.data ?? res;
        this.form = {
          name: data.name || '',
          phone: data.phone || '',
          email: data.email || '',
          address: data.address || '',
          isActive: data.isActive ?? true,
        };
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải thông tin đối tác.' });
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.validated = true;
      if (!this.form.name || !this.form.phone) return;

      try {
        const formData = new FormData();
        formData.append('name', this.form.name);
        formData.append('phone', this.form.phone);
        formData.append('email', this.form.email);
        formData.append('address', this.form.address);
        formData.append('isActive', this.form.isActive);

        if (this.isEdit) {
          await this.$api.put(`BcbPartner/${this.partnerId}`, formData);
          this.$toastr.s({ title: 'Thành công', msg: 'Đã cập nhật đối tác.' });
        } else {
          const res = await this.$api.post('BcbPartner', formData);
          this.$toastr.s({ title: 'Thành công', msg: 'Đã thêm đối tác mới.' });
          const newId = (res?.data ?? res)?.id || (res?.data ?? res);
          if (newId) {
            this.$router.replace({ name: 'bcb-partner-edit', params: { id: newId } });
            return;
          }
        }
        this.$router.push({ name: 'bcb-partner' });
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể lưu thông tin.' });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
